
import { defineComponent, onMounted, ref } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import AppService from "@/core/services/AppService";

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "en";

    const signOut = () => {
      store
        .dispatch(Actions.LOGOUT)
        .then(() => router.push({ name: "sign-in" }));
    };

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };
    let account_profile = ref({});
    onMounted(async () => {
      account_profile.value = await store.getters["currentUser"];
    });
    return {
      signOut,
      account_profile,
      AppService,
      setLang,
      currentLanguage,
    };
  },
});
